import { defineMessages } from 'react-intl';

export const miroDataFormatOptionsMessages = defineMessages({
	comments: {
		id: 'import-feedback.data-format-options.miro.comments',
		defaultMessage: 'Comments',
		description:
			'A single dropdown option indicating comments in Miro, as part of a feedback survey',
	},
	colors: {
		id: 'import-feedback.data-format-options.miro.colors',
		defaultMessage: 'Colors',
		description: 'A single dropdown option indicating colors in Miro, as part of a feedback survey',
	},
	connectors: {
		id: 'import-feedback.data-format-options.miro.connectors',
		defaultMessage: 'Connectors',
		description:
			'A single dropdown option indicating connectors in Miro, as part of a feedback survey',
	},
	rotations: {
		id: 'import-feedback.data-format-options.miro.rotations',
		defaultMessage: 'Rotations',
		description:
			'A single dropdown option indicating rotations in Miro, as part of a feedback survey',
	},
	shapes: {
		id: 'import-feedback.data-format-options.miro.shapes',
		defaultMessage: 'Shapes',
		description: 'A single dropdown option indicating shapes in Miro, as part of a feedback survey',
	},
	talkTracks: {
		id: 'import-feedback.data-format-options.miro.talk-tracks',
		defaultMessage: 'Talk Tracks',
		description:
			'A single dropdown option indicating talk tracks in Miro, as part of a feedback survey',
	},
	lockedElements: {
		id: 'import-feedback.data-format-options.miro.locked-elements',
		defaultMessage: 'Locked Elements',
		description:
			'A single dropdown option indicating locked elements in Miro, as part of a feedback survey',
	},
	stickyNotes: {
		id: 'import-feedback.data-format-options.miro.sticky-notes',
		defaultMessage: 'Sticky notes',
		description:
			'A single dropdown option indicating sticky notes in Miro, as part of a feedback survey',
	},
	frames: {
		id: 'import-feedback.data-format-options.miro.frames',
		defaultMessage: 'Frames',
		description: 'A single dropdown option indicating frames in Miro, as part of a feedback survey',
	},
	borders: {
		id: 'import-feedback.data-format-options.miro.borders',
		defaultMessage: 'Borders',
		description:
			'A single dropdown option indicating borders in Miro, as part of a feedback survey',
	},
	draw: {
		id: 'import-feedback.data-format-options.miro.draw',
		defaultMessage: 'Draw',
		description:
			'A single dropdown option indicating elements from the Draw tool in Miro, as part of a feedback survey',
	},
	websiteEmbeds: {
		id: 'import-feedback.data-format-options.miro.website-embeds',
		defaultMessage: 'Website embeds',
		description:
			'A single dropdown option indicating website embeds in Miro, as part of a feedback survey',
	},
	jiraCards: {
		id: 'import-feedback.data-format-options.miro.jira-cards',
		defaultMessage: 'Jira cards',
		description:
			'A single dropdown option indicating Jira cards in Miro, as part of a feedback survey',
	},
	tables: {
		id: 'import-feedback.data-format-options.miro.tables',
		defaultMessage: 'Tables',
		description: 'A single dropdown option indicating tables in Miro, as part of a feedback survey',
	},
	gifs: {
		id: 'import-feedback.data-format-options.miro.gifs',
		defaultMessage: 'GIFs',
		description: 'A single dropdown option indicating GIFs in Miro, as part of a feedback survey',
	},
	text: {
		id: 'import-feedback.data-format-options.miro.text',
		defaultMessage: 'Text',
		description: 'A single dropdown option indicating text in Miro, as part of a feedback survey',
	},
	stamps: {
		id: 'import-feedback.data-format-options.miro.stamps',
		defaultMessage: 'Stamps',
		description: 'A single dropdown option indicating stamps in Miro, as part of a feedback survey',
	},
	tags: {
		id: 'import-feedback.data-format-options.miro.tags',
		defaultMessage: 'Tags',
		description: 'A single dropdown option indicating tags in Miro, as part of a feedback survey',
	},
	mindMaps: {
		id: 'import-feedback.data-format-options.miro.mind-maps',
		defaultMessage: 'Mind maps',
		description:
			'A single dropdown option indicating mind maps in Miro, as part of a feedback survey',
	},
	other: {
		id: 'import-feedback.data-format-options.miro.other',
		defaultMessage: 'Other',
		description:
			'A single dropdown option indicating any feature that is not listed by the other options, as part of a feedback survey',
	},
});
